import { useEffect, useState } from "react";
import { Drawer } from "../../components/Drawer";
import { Tabs } from "../../components/Tabs";

import styles from "../../../styles/banners.module.scss";
import { Button } from "../../components/Button";
import { Icon } from "../../components/core/Icon";
import { Banners } from "shared/core/Banners";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";

const BannersSort = ({
  visible,
  onClose,
  alias,
  category,
  devices,
  title,
  onSave
}) => {

  const controller = new Banners();

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(devices?.[0]?.key);
  const [selected_category, setSelectedCategory] = useState(category);
  const [holdingId, setHoldingId] = useState(null);

  const getHoldingId = async () => {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    setHoldingId(holdingId);
  };

  useEffect(() => {
    getHoldingId();
  }, []);

  const isCiaTC = holdingId && holdingId === 811;

  useEffect(() => { setSelectedCategory(category) }, [category]);

  const onSwitchPosition = (bannerIndex, direction, device) => {
    const newIndex = direction === "up" ? bannerIndex - 1 : bannerIndex + 1;

    const arr = [...(selected_category[device] || [])];
    const currentBannerOnPosition = arr[bannerIndex];
    const newBannerOnPosition = arr[newIndex];
    arr[newIndex] = currentBannerOnPosition;
    arr[bannerIndex] = newBannerOnPosition;

    setSelectedCategory({ ...selected_category, [device]: arr });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const success = await controller.setCategory(alias, selected_category, isCiaTC ? holdingId : null);
    setLoading(false);
    if (success === true) {
      onSave && onSave();
    }
  };

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title="Ordenar Banners"
      subtitle={title}
    >
      <Tabs
        full
        tabs={devices}
        onTabSelected={(tab) => setActiveTab(tab)}
        activeTab={activeTab}
      />

      <div className={styles.sortBannersScroll}>
        {selected_category[activeTab] && (
          <div className={styles.sortBanners}>
            {selected_category[activeTab].map((banner, index, arr) => {
              return (
                <div className={styles.item} key={index}>
                  <div className="d-flex align-center">
                    <div className={styles.image}>
                      <img
                        src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.image}`}
                        alt={banner?.name}
                      />
                    </div>
                    {banner?.name && (
                      <p className={styles.name}>{banner?.name}</p>
                    )}
                  </div>
                  <div className={styles.chevrons}>
                    {index !== 0 ? (
                      <div className={styles.icon}>
                        <Icon
                          name="chevron-up"
                          size="1x"
                          solid
                          onClick={() => onSwitchPosition(index, "up", activeTab)}
                        />
                      </div>
                    ) : null}
                    {index !== arr.length - 1 ? (
                      <div className={styles.icon}>
                        <Icon
                          name="chevron-down"
                          size="1x"
                          solid
                          onClick={() => onSwitchPosition(index, "down", activeTab)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <Button 
          design="primary" 
          className="w-100" 
          disabled={loading}
          loading={loading}
          onClick={() => handleSubmit()}
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};

export default BannersSort;
